module.exports = __webpack_public_path__ + "img/xmgjLogo.7a9fc10e.png";